var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"renderer-string-content",attrs:{"title":_vm.formatData(_vm.value)}},[_vm._v(_vm._s(_vm.formatData(_vm.value)))])
}
var staticRenderFns = []

export { render, staticRenderFns }